import React, { useState } from 'react';
import BlindStructureTable from './components/BlindStructureTable';
import BlindStructureModalForm from './components/BlindStructureModalForm';
import { Button } from 'reactstrap';
import StandardLayout from '@/common/layouts/StandardLayout';
import { FaPlus } from 'react-icons/fa';

const BlindStructuresPage = () => {
  const [formOpen, setFormOpen] = useState(false);
  const [selectedBlindStructureId, setSelectedBlindStructureId] = useState<string | null>(null);

  const openForm = () => setFormOpen(true);

  const closeForm = () => {
    setSelectedBlindStructureId(null);
    setFormOpen(false);
  };

  const onSelectBlindStructure = (id: string) => {
    setSelectedBlindStructureId(id);
    openForm();
  };

  return (
    <StandardLayout
      pageTitle="Tournament Blind Structures"
      headerButton={
        <Button onClick={openForm} color="primary" className="d-flex align-items-center gap-2">
          <FaPlus />
          <p className="mb-0">Add Blind Structure</p>
        </Button>
      }
    >
      <BlindStructureTable onSelectBlindStructure={onSelectBlindStructure} />
      {formOpen && <BlindStructureModalForm onClose={closeForm} selectedBlindStructureId={selectedBlindStructureId} />}
    </StandardLayout>
  );
};

export default BlindStructuresPage;
